import * as qz from "qz-tray";
import { sha256 } from "js-sha256";
import { hextorstr, KEYUTIL, KJUR, stob64 } from "jsrsasign";
import store from "../store/store";

// Configure QZ Tray with certificates and signing
qz.api.setSha256Type(data => sha256(data));
qz.api.setPromiseType(resolver => new Promise(resolver));

qz.security.setCertificatePromise(function (resolve) {
  resolve(`-----BEGIN CERTIFICATE-----
MIIFCDCCAvCgAwIBAgIQNzkyMDI2MDcxOTE4MzQ0MDANBgkqhkiG9w0BAQ0FADCB
mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry
aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ
cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz
dHJpZXMuY29tMB4XDTI2MDcxOTE4MzQ0MFoXDTI3MDcyMjIzMzAyNFowgcMxCzAJ
BgNVBAYMAlVTMRMwEQYDVQQIDApOZXcgSmVyc2V5MRAwDgYDVQQHDAdQYXJhbXVz
MQ0wCwYDVQQKDARCaXlvMQ0wCwYDVQQLDARCaXlvMQ0wCwYDVQQDDARCaXlvMSIw
IAYJKoZIhvcNAQkBDBNtYXR0QGJpeW93YWxsZXQuY29tMTwwOgYDVQQNDDNyZW5l
d2FsLW9mLTJjMDJkMWQzYzg5YzMxMDc1ODA5MjQzMTY3MmI4YmIwOTU1ZmMyZTAw
ggEgMAsGCSqGSIb3DQEBAQOCAQ8AMIIBCgKCAQEAmOP8o8t6hj2A52OAQ08GjV1S
t0E08f681dL1QBjnarDuOMPFlvbnziR8n1c4fmODLNPdmJ1+ZOliTpVDkbD9xNFj
CoxHkpPOiGY5glGLdcI8LMy356F4R6hw+MDY1KLMfWC4K4X4N8/6bwjEU/9oqrtE
+lPcPUN3RilveER2gbjQyAt62CH/acYY1BASUQj0Ba8dvYflTqp0DMYm5C4Y9uuP
h1sML1cI5i6SBBRxWvFM8UfgIgu5tA3v/QGRV8GiEXcBoEwzMiXrZGldEx+wi5Eo
fkaAhmBsZo0TDp5+tFDK31m7ecwFEOtab2j3qI5yzKJVyPYJn6mb5cw/sz+iBQID
AQABoyMwITAfBgNVHSMEGDAWgBSQplC3hNS56l/yBYQTeEXoqXVUXDANBgkqhkiG
9w0BAQ0FAAOCAgEAL8vWT28dNx09bNj7RBlKS0ZpBe8j7FQjAYLze4jKcEpkcdTp
hNhQwsojn4N1ll5R54Q0vdleS2175D6Tx2aQnO4KXK6VkyrCcqj5EpJxSel69tKF
jdhd3ftzReZG+zj8l95l5nfD7LtLUEADeuKJv6bokNtb9SjG/HUxS8aXhgj492s7
naPsxb27pwbv54l8ttALn0WQJ/IHCliFHj2bOgO/mFiAPSVKNJX+wx20MYM0pLxo
jFC551kykYEih7vBxIXQnhVSPrVo/R0zviHyYWga8Aq8DLfbJ6/tW8q1OUYI7xbJ
Y7IAMmjwBvImuRs8jh9NX33QozSC1DrFU/rfxs5mQfBpVt4vVGu0+K6K+vf2oimF
dAnWAO8Hhr2GK7xG+sjAbSDMXcXYODMfXw1pdM99S6XPuTpTzwp8FjA2eIPOOleS
YbHXI9tGFF0X3kOqm/adr1U416UZYnTsnZt++37iLD9aXI8t7eSK1B08T8WAI5mf
IdGAZ81h0cchL1PpAWLVzLdWmUTx36l328B0PW6znAaBNCRgM6G+kMkFyq9xUGRf
6UCBIo7/98bMLHyeqvDCVf6PKx2NYdUm3MsYrmYclJ/WRP7gCEhzAw6bi1ex/aDO
H/YhUnoq+WatJs5BbIp/Q0OOQzcigz8WZWsSczn/uj3MvQ2Go5bCep8FNJI=
-----END CERTIFICATE-----
--START INTERMEDIATE CERT--
-----BEGIN CERTIFICATE-----
MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT
MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ
bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG
A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx
emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow
gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0
cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM
EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1
c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU
iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H
YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM
GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH
EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh
0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX
xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1
9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE
ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD
2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX
6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY
5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ
plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S
BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ
eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k
gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT
x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu
pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw
2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp
rbO7BnjW
-----END CERTIFICATE-----`);
});

const privateKey = "-----BEGIN PRIVATE KEY-----\n" +
  "MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCY4/yjy3qGPYDn\n" +
  "Y4BDTwaNXVK3QTTx/rzV0vVAGOdqsO44w8WW9ufOJHyfVzh+Y4Ms092YnX5k6WJO\n" +
  "lUORsP3E0WMKjEeSk86IZjmCUYt1wjwszLfnoXhHqHD4wNjUosx9YLgrhfg3z/pv\n" +
  "CMRT/2iqu0T6U9w9Q3dGKW94RHaBuNDIC3rYIf9pxhjUEBJRCPQFrx29h+VOqnQM\n" +
  "xibkLhj264+HWwwvVwjmLpIEFHFa8UzxR+AiC7m0De/9AZFXwaIRdwGgTDMyJetk\n" +
  "aV0TH7CLkSh+RoCGYGxmjRMOnn60UMrfWbt5zAUQ61pvaPeojnLMolXI9gmfqZvl\n" +
  "zD+zP6IFAgMBAAECggEAF+M7JF5U4Od4He76acnNlMW5eD9cZdjuqRviTKb3dUB6\n" +
  "n+zakNk344no3L50aa7jnlvl2gP1bQ/X175Thc5Y/+jVKB89yYWFdeM+5gEWoIn9\n" +
  "++PqcerVD6EeMYdz+VkMSSSU8dvnKdU5ZCLDBfq4YECNKO10UjAZ0SEFNQ3BVEgN\n" +
  "p3Kva4LNXxm6IMppVSbKXoesig6bwAIETCjCpJJMtiBgjCvrsWJUk6y7a+q4doYg\n" +
  "Ixfc9OUkwdSd2kUQR82d3sgqBd8hIKAx5gbrzjPblpa2iAguiWGjZZUe/DFJ/+jA\n" +
  "hXkwA7PzvU99GPXmNqFUVenvkaDKGBIDndcv3hcGgQKBgQDII5pUC//u6GnPRW8y\n" +
  "lLCWhid6JtkMeyoNXITngWn1PhWDrS4vPZv0zD1dgE87iwT82Wuou8NcKT2RQ1Sz\n" +
  "oFCvUrQQl0Ne/3rqsC5RjWUBJHkVGTV3rXIkQ/W31iMExACRx4Mxpaqb+EyiwATL\n" +
  "pj6xit8x28G0s/kfLX3KyBFQwQKBgQDDkF66nLmmWkGRXDZkA/7fck2Y0d6kQhmt\n" +
  "DM7Vn1IQfES47AbjvKpEJBwnoqfjA7kxn63ps6iw+NKNlJaJ6nI+c46U1HP/JMWQ\n" +
  "4WmQYDLFcU/gH6hnGbRfOxEl6QJT/pH9j0BLOnLnSIRBiwojXtCjFjp1h2pdxkwg\n" +
  "q0kmuG5eRQKBgQCc31MzN6im8aMmJO2Q/v0fLw44b8THRK7khDVkZIrSAJTKfm7p\n" +
  "9meMzJ348P6p1EDXk/AP9QSe83BfsR/uH+W+VpvvOTFEgAovdGMJ50NZTuZdhEHl\n" +
  "iZ0jEeXC7+TI8nzjxzdtLcZ5tHkVRF895RPVA94IbZD6e+rz5itoS8NOwQKBgDn7\n" +
  "iQqdQzH+Wqhlhb7brGrFshoYR4G+E2zKely+Ew/OOHX3jQdivbzcU/iwckSNqw/6\n" +
  "fw7mdKKb85mEr6mOeHbpviGEaCwC1AzjuG/VBdiigwM5f62p4l/F3Iy37DfJJ7Hd\n" +
  "Ejv7xWurhYMFXWklSIjCI20LTE8nZxTclCDF1/tdAoGBAIMw0hzgjymoqq9oADQn\n" +
  "4DYp69LWHy1aoGfaBBAqNw222VHPt2D8vhFdzse+GwOP3tSPWReg6z8R/CjIunnw\n" +
  "C6WwTrYVOecmJBSYSZ6GWh/I57QDsNPtWKepP3Hs8YtePV4tyzADdFRiCizdfaf+\n" +
  "eW/C93o743kyB+xcHpMq4+ZB\n" +
  "-----END PRIVATE KEY-----";

qz.security.setSignatureAlgorithm("SHA512");
qz.security.setSignaturePromise(function (toSign) {
  return function (resolve, reject) {
    try {
      const pk = KEYUTIL.getKey(privateKey);
      const sig = new KJUR.crypto.Signature({ "alg": "SHA512withRSA" });
      sig.init(pk);
      sig.updateString(toSign);
      const hex = sig.sign();
      resolve(stob64(hextorstr(hex)));
    } catch (err) {
      console.error("QZ Tray signature error:", err);
      reject(err);
    }
  };
});

/**
 * Initialize QZ Tray connection on app startup
 * This ensures QZ Tray is ready before any print operations
 */
export async function initializeQzTray() {
  try {
    // Check if QZ Tray is already connected
    if (qz.websocket.isActive()) {
      return { success: true, alreadyConnected: true };
    }
    
    // Get terminal configuration for printer server IP
    const terminal = store.getters["config/terminal"];
    const connectOptions = terminal?.printer_server_ip 
      ? { host: terminal.printer_server_ip } 
      : {};

    // Connect to QZ Tray
    await qz.websocket.connect(connectOptions);
    
    return { 
      success: true, 
      version: qz.api.getVersion(),
      alreadyConnected: false 
    };
    
  } catch (error) {
    console.error("Failed to initialize QZ Tray:", error);
    
    // Log specific error types
    if (error.message && error.message.includes("Unable to establish connection")) {
      console.error("QZ Tray is not running. Please start QZ Tray application.");
    }
    
    return { 
      success: false, 
      error: error.message || "Unknown error",
      alreadyConnected: false 
    };
  }
}

/**
 * Check QZ Tray connection status
 */
export function isQzTrayConnected() {
  return qz.websocket.isActive();
}

/**
 * Disconnect QZ Tray (useful for cleanup)
 */
export async function disconnectQzTray() {
  try {
    if (qz.websocket.isActive()) {
      await qz.websocket.disconnect();
      return { success: true };
    }
    return { success: true, message: "Already disconnected" };
  } catch (error) {
    console.error("Error disconnecting QZ Tray:", error);
    return { success: false, error: error.message };
  }
}

/**
 * Get QZ Tray version
 */
export function getQzTrayVersion() {
  try {
    if (qz.websocket.isActive()) {
      return qz.api.getVersion();
    }
    return null;
  } catch (error) {
    console.error("Error getting QZ Tray version:", error);
    return null;
  }
}
